<div class="row">
    <div class="col-12">
        <div class="spinner-container" >
            <span class="fa fa-cog fa-spin"></span>
            <p class="loading-text">Loading...</p>
        </div>
    </div>
</div>
